const PIERRE_WEBVIEW_USER_AGENT = /\bPierreWebView(?:\/|\b)/i;

export function isPierreWebViewUserAgent(userAgent: string) {
  return PIERRE_WEBVIEW_USER_AGENT.test(userAgent);
}
